import { makeStyles } from "@material-ui/core";

export const useNavigatorStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		maxWidth: "fit-content",
		minWidth: 320,
	},
	container: {
		display: "flex",
		alignItems: "center",
		"& > *:not(:last-child)": {
			marginRight: theme.spacing(1),
		},
	},
	title: {
		height: 40,
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0, 2),
		borderRadius: 6,
		fontWeight: 500,
		minWidth: 60,
		textAlign: "center",
		textTransform: "uppercase",
	},
	iconButton: {
		height: "100%",
		width: 40,
		backgroundColor: "#4051b5",
		color: "#fff",
		borderRadius: 6,
		boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
		transition: "background-color 0.2s ease",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: theme.palette.primary.dark,
			cursor: "pointer",
		},
	},
	statusContainer: {
		color: "#fff",
		borderRadius: 4,
		padding: theme.spacing(1, 2),
		textAlign: "center",
		marginLeft: theme.spacing(1),
		minWidth: 100,
	},
}));
